const clinicType = 'physio';
const isProd = process.env.REACT_APP_USER_API_URL.includes('prod');

const config = {
    clinicType,
    isProd,
    mixpanelToken: isProd
        ? '189e32a152f429590258281c65ec1492' // physio prod token
        : '3670bd50f368dec66e70e31dd0090f8e', // physio dev/staging token

    loginBanner: require('./assets/banners/loginPageBannerPhysio.png'),

    cetraBlueLogo: require('./assets/logos/cetra_blue_physio.png'),

    cetraMobileLogo: require('./assets/logos/cetra_marque.png'),

    gtagId: process.env.REACT_APP_GTAG_ID || '',

    accountTypes: [
        {
            type: 'Student',
            title: "I'm a student",
            description: 'I am pursuing a degree/course relating to MSK.',
        },
        {
            type: 'Professional',
            title: "I'm a professional",
            description: 'I will use Cetra to enhance my work as an individual.',
        },
        {
            type: 'Clinic',
            title: "I'm the admin of a clinic",
            description: 'I want to use Cetra to support and improve the care my clinic delivers.',
        },
    ],

    feedbackText:
        'We highly appreciate detailed information, as it plays a crucial role in fulfilling our mission of offering comprehensive medical knowledge.',

    landingPageUrl: 'https://www.cetrahealth.com',

    surveyUrl: 'https://form.jotform.com/Cetra_hello/cetra-health-feedback?_kx=Cp7DmMHPcQJ9CvW4TnAWkQ.USbu7j',

    tsCsUrl: 'https://www.cetrahealth.com/legal/terms-of-service',

    upgradeImages: {
        paywall: {
            clinic: require('./assets/banners/ctaUpgradeClinicPaywallPhysio.png'),
            professional: require('./assets/banners/ctaUpgradeProfessionalPaywallPhysio.png'),
        },
        settings: {
            clinic: {
                desktop: require('./assets/banners/ctaUpgradeClinicPhysio.png'),
                mobile: require('./assets/banners/ctaUpgradeClinicMobilePhysio.png'),
            },
            professional: {
                desktop: require('./assets/banners/ctaUpgradeProfessionalPhysio.png'),
                mobile: require('./assets/banners/ctaUpgradeProfessionalMobilePhysio.png'),
            },
            trial: {
                desktop: require('./assets/banners/ctaUpgradeTrialPhysio.png'),
                mobile: require('./assets/banners/ctaUpgradeTrialMobilePhysio.png'),
            },
        },
    },

    practiceOrClinicText: 'clinic',
    // annualDiscountText: 'Save 5% with annual plans',
};

export const getCTAUpgradeImageUrl = (type) => {
    return config.upgradeImages.paywall[type];
};

export const getCTAUpgradeSettingsImageUrl = (planType, isMobile = false) => {
    const viewPort = isMobile ? 'mobile' : 'desktop';
    return config.upgradeImages.settings[planType][viewPort];
};

export const cetraBlueLogo = config.cetraBlueLogo;
export const cetraMobileLogo = config.cetraMobileLogo;
export const feedbackMessage = config.feedbackText;
export const landingPageUrl = config.landingPageUrl;
export const surveyUrl = config.surveyUrl;
export const tsCsUrl = config.tsCsUrl;
export const practiceOrClinicText = config.practiceOrClinicText;

export default config;
